const prefix = 'fasr';
const iconName = 'message-captions';
const width = 512;
const height = 512;
const aliases = ['comment-alt-captions'];
const unicode = 'e1de';
const svgPathData = 'M160 512l48-32 96-64H464h48V368 48 0H464 48 0V48 368v48H48h64 48v38.3V464v48zM277.4 376.1L208 422.3V416 368H160 48V48H464V368H304 289.5l-12.1 8.1zM120 192H96v48h24H264h24V192H264 120zm224 0H320v48h24 48 24V192H392 344zM120 272H96v48h24 48 24V272H168 120zm128 0H224v48h24H392h24V272H392 248z';

export default {
  prefix,
  iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ] };
